<template>
  <CrudForm :title="title" :labelSubmit="labelSubmit" :storeName="storeName" :parentStoreName="parentStoreName"
    :submit="submit" :status="status" labelBack="Atrás" :canCancel="true" removeText="Eliminar spot"
    :urlSendNotification="url_send_notification" :breadcrumbs="[
      {
        text: 'Spots y vehículos',
        disabled: false,
        href: '/admin/notifications_cms'
      },
      {
        text: '...',
        disabled: false,
        href: '#'
      },
      {
        text: 'Detalles',
        disabled: true,
        href: '#'
      }
    ]">
    <ValidationObserver ref="validator" v-slot="{ }">

      <v-row justify="center" no-gutters>
        <v-col cols="12" sm="11" md="11" lg="8">
          <v-row no-gutters>
            <v-col class="py-0 px-2">
              <ValidationProvider ref="address" rules="" v-slot="{ errors }">
                <div class="label-base pb-1">Lugar</div>
                <v-text-field id="pac-input" :error-messages="errors" v-model="data.address" label="Lugar" solo
                  hide-details="auto" class="input-base"></v-text-field>
              </ValidationProvider>
              <GoogleMapLoader v-on:select="changeAddress" :show-map="false" style="height: 300px"
                :sendCoordinates="sendCoordinates" />
            </v-col>
          </v-row>
          <v-row no-gutters class="mt-2">
            <v-col cols="5" class="py-0 px-2">
              <ValidationProvider ref="latitude" rules="" v-slot="{ errors }">
                <div class="label-base pb-1">Latitud</div>
                <v-text-field :error-messages="errors" v-model.number="data.latitude" type="Number" label="Latitud" solo
                  hide-details="auto" class="input-base no-spinner">
                  <template #append>
                    <div class="number-controls">
                      <v-icon @click="() => data.latitude++">
                        $chevronUpIcon
                      </v-icon>
                      <v-icon @click="() => data.latitude--">
                        $chevronDownIcon
                      </v-icon>
                    </div>
                  </template>
                </v-text-field>
              </ValidationProvider>
            </v-col>
            <v-col cols="5" class="py-0 px-2">
              <ValidationProvider ref="longitude" rules="" v-slot="{ errors }">
                <div class="label-base pb-1">Longitud</div>
                <v-text-field :error-messages="errors" type="Number" v-model.number="data.longitude" label="Longitud"
                  solo hide-details="auto" class="input-base  no-spinner">
                  <template #append>
                    <div class="number-controls">
                      <v-icon @click="() => data.longitude++">
                        $chevronUpIcon
                      </v-icon>
                      <v-icon @click="() => data.longitude--">
                        $chevronDownIcon
                      </v-icon>
                    </div>
                  </template>
                </v-text-field>
              </ValidationProvider>
            </v-col>
            <v-col cols="2" class="py-0 px-2">
              <ValidationProvider ref="verified" rules="" v-slot="{ errors }">
                <div class="label-base pb-1"></div>
                <v-checkbox :error-messages="errors" label="Verified" v-model.number="data.verified"
                  class="input-check-base mt-5" hide-details="auto" on-icon="$checkedIcon" off-icon="$unCheckedIcon">
                </v-checkbox>
              </ValidationProvider>
            </v-col>
            <!--  <v-col class="py-0 px-2">
                <ValidationProvider ref="is_automatic" rules="" v-slot="{ errors }">
                  <v-checkbox :error-messages="errors" label="is_automatic" v-model.number="data.is_automatic">
                  </v-checkbox>
                </ValidationProvider>
              </v-col> -->
          </v-row>
          <v-row no-gutters class="mt-2">
            <v-col>
              <ValidationProvider ref="unit" rules="" v-slot="{ errors }">
                <div class="label-base pb-1">Spot Precio Hora</div>
                <v-text-field id="pac-input" :error-messages="errors" v-model="data.spot_price_hour" label="Spot Precio Hora" solo
                              hide-details="auto" class="input-base">
                  <template #append>
                    <div class="number-controls">
                      <v-icon @click="() => data.latitude++">
                        $chevronUpIcon
                      </v-icon>
                      <v-icon @click="() => data.latitude--">
                        $chevronDownIcon
                      </v-icon>
                    </div>
                  </template>
                </v-text-field>
              </ValidationProvider>
            </v-col>
            <v-col>
              <ValidationProvider ref="name" rules="" v-slot="{ errors }">
                <div class="label-base pb-1">Nombre</div>
                <v-text-field id="pac-input" :error-messages="errors" v-model="data.name" label="Nombre" solo
                              hide-details="auto" class="input-base"></v-text-field>
              </ValidationProvider>
            </v-col>
            <v-col>
              <ValidationProvider ref="subtype" rules="" v-slot="{ errors }">
                <div class="label-base pb-1">Sub Tipo</div>
                <v-text-field id="pac-input" :error-messages="errors" v-model="data.subtype" label="Sub Tipo" solo
                              hide-details="auto" class="input-base"></v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row no-gutters class="mt-2">
            <v-col class="py-0 px-2">
              <ValidationProvider ref="province_id" rules="required" v-slot="{ errors }">
                <div class="label-base pb-1">Provincia</div>
                <v-select :error-messages="errors" v-model="data.province_id" :items="provinces" item-text="name"
                  item-value="id" label="Provincia" solo hide-details="auto" class="input-base"
                  append-icon="$caretDownFormIcon"></v-select>
              </ValidationProvider>
            </v-col>
            <v-col class="py-0 px-2">
              <ValidationProvider ref="city_id" rules="" v-slot="{ errors }">
                <div class="label-base pb-1">Ciudad</div>
                <v-select :error-messages="errors" v-model="data.city_id" :items="cities" item-text="name"
                  item-value="id" label="Ciudad" solo hide-details="auto" class="input-base"
                  append-icon="$caretDownFormIcon"></v-select>
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row no-gutters class="mt-2">
            <v-col class="py-0 px-2">
              <ValidationProvider ref="street" rules="" v-slot="{ errors }">
                <div class="label-base pb-1">Calle</div>
                <v-text-field id="pac-input" :error-messages="errors" v-model="data.street" label="Calle" solo
                              hide-details="auto" class="input-base"></v-text-field>
              </ValidationProvider>
            </v-col>
            <v-col class="py-0 px-2">
              <ValidationProvider ref="number" rules="" v-slot="{ errors }">
                <div class="label-base pb-1">Número</div>
                <v-text-field id="pac-input" :error-messages="errors" v-model="data.number" label="Número" solo
                              hide-details="auto" class="input-base"></v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row no-gutters class="mt-2">
            <v-col cols="4" class="py-0 px-2">
              <ValidationProvider ref="status" rules="required" v-slot="{ errors }">
                <div class="label-base pb-1">Estado</div>
                <v-select :error-messages="errors" v-model="data.status" label="Estado" :items="status_types" solo
                  hide-details="auto" class="input-base" append-icon="$caretDownFormIcon">
                  <template slot="no-data">
                    <v-alert :value="true"> No hay datos a mostrar </v-alert>
                  </template>
                </v-select>
              </ValidationProvider>
            </v-col>
            <v-col cols="4" class="py-0 px-2">
              <ValidationProvider ref="size" rules="required" v-slot="{ errors }">
                <div class="label-base pb-1">Tamaño</div>
                <v-select :error-messages="errors" v-model="data.size_spot_id" :items="size_spots" item-text="title"
                  item-value="id" label="Tamaño" solo hide-details="auto" class="input-base"
                  append-icon="$caretDownFormIcon"></v-select>
              </ValidationProvider>
            </v-col>
            <v-col cols="4" class="py-0 px-2">
              <ValidationProvider ref="type_spot_id" rules="required" v-slot="{ errors }">
                <div class="label-base pb-1">Tipo</div>
                <v-select :error-messages="errors" v-model="data.type_spot_id" :items="type_spots" item-text="name"
                  item-value="id" label="Tipo" solo hide-details="auto" class="input-base"
                  append-icon="$caretDownFormIcon"></v-select>
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row no-gutters class="mt-2">
            <v-col cols="12" class="py-0 px-2">
              <ValidationProvider ref="seat_quantity" rules="" v-slot="{ errors }">
                <div class="label-base pb-1">Cantidad de Espacios</div>
                <v-text-field
                    id="pac-input"
                    :error-messages="errors"
                    v-model="data.seat_quantity"
                    label="Cantidad de Espacios"
                    solo
                    hide-details="auto"
                    class="input-base"
                >
                </v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row no-gutters class="mt-2">
            <v-col class="py-0 px-2">
              <ValidationProvider ref="description" rules="" v-slot="{ errors }">
                <div class="label-base pb-1">Descripción</div>
                <v-textarea :error-messages="errors" v-model="data.description" label="" solo
                  placeholder=" Ingrese aquí la información adicional" hide-details="auto" class="text-tarea-base"
                  counter="200" :rules="[v => v.length <= 200 || 'Máximo 200 caracteres']" rows="8">
                </v-textarea>
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row no-gutters class="mt-2">
            <v-col class="py-0 px-2">

              <v-checkbox v-model="data.deleted" label="Eliminado" class="input-check-base mt-0" hide-details="auto"
                on-icon="$checkedIcon" off-icon="$unCheckedIcon">
              </v-checkbox>
            </v-col>
            <v-col class="py-0 px-2">

              <v-checkbox v-model="data.home_constancy" label="Constancia domicilio" class="input-check-base mt-0"
                hide-details="auto" on-icon="$checkedIcon" off-icon="$unCheckedIcon"></v-checkbox>
            </v-col>
            <v-col class="py-0 px-2">

              <v-checkbox v-model="data.has_sticker" label="Cartel colocado " class="input-check-base mt-0"
                hide-details="auto" on-icon="$checkedIcon" off-icon="$unCheckedIcon"></v-checkbox>
            </v-col>
          </v-row>

          <v-row class="mt-2" no-gutters>
            <v-col class="py-0 px-2">
              <ValidationProvider ref="type" rules="" v-slot="{ errors }">
                <div class="label-base pb-1">Comodidades</div>
                <v-select :error-messages="errors" v-model="data.amenities" label="Comodidades" :items="amenities"
                          item-text="name" item-value="id" multiple solo hide-details="auto" class="input-base"
                          append-icon="$caretDownFormIcon">
                  <template slot="no-data">
                    <v-alert :value="true"> No hay datos a mostrar </v-alert>
                  </template>
                </v-select>
              </ValidationProvider>
            </v-col>
          </v-row>

          <v-row no-gutters class="mt-4">
            <v-col class="py-0 px-2">
              <ValidationProvider ref="picture" rules="" v-slot="{ errors }">
                <UploadDrop :error-messages="errors" accept="image/png, image/jpeg, image/jpg"
                  placeholder="Imagen de Spots" title="Imagen del spot" label="" :multiple="false"
                  :onSelectedPicture="onSelectedPicture"></UploadDrop>
                <!-- <Upload
                    :error-messages="errors"
                    accept="image/png, image/jpeg, image/jpg"
                    placeholder="Imagen de Spots"
                    prepend-icon="fas fa-camera"
                    label=""
                    :multiple="false"
                    :onSelectedPicture="onSelectedPicture"
                  ></Upload>
                  <v-img
                    :src="picture_poster"
                    width="200"
                    style="margin: auto"
                  ></v-img> -->
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row no-gutters class="mt-4" v-if="images_poster && images_poster.length > 0">
            <v-col class="py-0 px-2" cols="12">
              Fotos Poster
            </v-col>
          </v-row>

          <div class="images_poster mt-2" v-if="images_poster && images_poster.length > 0">
            <v-row no-gutters>
              <v-col v-for="(item, i) in images_poster" :key="'img_' + i" class="py-0 px-2 d-flex child-flex" cols="3">
                <a :href="item" target="_blank">
                  <img :src="item" alt="" title="" class="img-default" />
                </a>
              </v-col>
            </v-row>
          </div>
          <v-row no-gutters class="mt-2" v-if="spot_document.spot_document">
            <v-col class="py-0 px-2">
              <v-btn text class="mr-5" :href="spot_document.spot_document" target="_blank">
                <v-icon left>fas fa-file</v-icon>
                Documento de Spot
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </ValidationObserver>

  </CrudForm>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { mapState } from "vuex";
import Upload from "@/components/Upload";
import UploadDrop from "@/components/UploadDragAndDrop";
import CrudForm from "@/components/Crud/CrudForm";
import CrudFormMixin from "@/mixins/crud_form";
import GoogleMapLoader from "@/components/maps/GoogleMapLoader";
//import VueLightbox from 'vue-lightbox'
export default {
  mixins: [CrudFormMixin],
  components: {
    ValidationProvider,
    ValidationObserver,
    CrudForm,
    GoogleMapLoader,
    //VueLightbox,
    Upload,
    UploadDrop
  },
  computed: {
    ...mapState({
      status: (state) => state.Spots.status,
      type_spots: (state) => state.Type_spots.list,
      size_spots: (state) => state.Size_spots.list,
      provinces: (state) => state.Provinces.list,
      cities: (state) => state.Cities.list,
      amenities: state => state.Amenities.list
    }),
  },
  mounted() { },
  async created() {
    this.loadCreated()
  },
  data() {
    return {
      spot_document: {
        spot_document: null,
      },
      images_poster: [],
      storeName: "Notifications_cms",
      parentStoreName: "Notification_cms",
      title: "Detalle de spot",
      url_send_notification: "",
      status_types: [
        "in_use",
        "available",
        "unavailable",
        "verification_rejected",
      ],
      //size_types: ['standart','compact', 'medium','big','xl'],
      availability_types: ["full_time", "part_time", "my_time"],
      filteredAttributes: ["picture"],
      picture_poster: "",
      data: {
        id: "",
        user_id: "",
        address: "",
        street: "",
        number: "",
        latitude: "",
        longitude: "",
        //location: "",
        size_spot_id: "",
        status: "",
        //availability: "",
        type_spot_id: "",
        home_constancy: false,
        verified: false,
        deleted: false,
        description: "",
        picture: undefined,
        //is_automatic: false,
        province_id: "",
        city_id: "",
        has_sticker: "",
        seat_quantity: "",
        spot_price_hour: "",
        subtype: "",
        name: "",
        amenities: []
      },
      time_to: "",
      time_from: "",
      menu_time_to: false,
      menu_time_from: false,
    };
  },
  watch: {
    time_to(val) {
      this.time_to = val;
      this.data.time_to = this.formatDateForSave(val);
    },
    time_from(val) {
      this.time_from = val;
      this.data.time_from = this.formatDateForSave(val);
    },
    async "data.province_id"(val) {
      this.data.city_id;
      await this.$store.dispatch("Cities/getListAll", {
        enable: true,
        province_id: val,
      });
    },
    '$route.params.id': {
      immediate: true,
      async handler(newId, oldId) {
        if (newId && newId !== oldId) {
          Object.assign(this.$data, this.$options.data.call(this))
          this.loadCreatedGlobal()
          this.loadCreated()
        }
      },
    },
  },
  methods: {
    sendCoordinates(lat, lng) {
      this.data.latitude = lat;
      this.data.longitude = lng;
    },
    changeAddress(val) {
      this.data.address = val;
    },
    onSelectedPicture(file) {
      const self = this;
      this.data.picture = file;

      let fr = new FileReader();
      fr.onload = function () {
        self.picture_poster = fr.result;
      };
      fr.onerror = function () {
        self.picture_poster = "";
      };
      fr.readAsDataURL(this.data.picture);
    },
    async loadCreated() {
      const self = this;
      let filters = {};
      if (this.$route.params.id) {
        await self.$store
          .dispatch("Spots/show", this.$route.params.id)
          .then((data) => {
            if (data.user_id) {
              self.url_send_notification = `/admin/notification_cms/message/send/${data.id}`;
            }
            for (let i in data) {
              if (
                self.data[i] !== undefined &&
                !self.filteredAttributes.includes(i)
              ) {
                self.data[i] = data[i];
              } else {
                if (
                  self.filteredAttributes.includes(i) &&
                  self[i] !== undefined
                ) {
                  self[i] = data[i];
                }
              }
            }

            this.data.size_spot_id = data.size;
            this.data.type_spot_id = data.type_spot;
          });

        await self.$store
          .dispatch("Spots/show", this.$route.params.id)
          .then(async (val) => {
            this.data.type_spot_id = val.type_spot;
            await this.$store.dispatch("Cities/getListAll", {
              enable: true,
              province_id: val.province_id,
            });
            this.spot_document = {
              ...this.spot_document,
              ...val.spot_document,
            };
          });

        filters.spot_id = this.$route.params.id;
        const posters = await self.$store.dispatch("Posters/getListAll", {
          spot_id: filters.spot_id,
        });
        if (posters && posters.length > 0) {
          const poster = posters[0];
          const valid_photos = poster.photos.filter((item) => item.photo);
          this.images_poster = valid_photos.map((item) => item.photo);
        }
      }
      await self.$store.dispatch("Spots/getListAll", filters);
      await self.$store.dispatch("Type_spots/getListAll", filters);
      await self.$store.dispatch("Size_spots/getListAll", {});
      await self.$store.dispatch("Provinces/getListAll", { enable: true });
      await this.$store.dispatch("Amenities/getListAll", { show_all: "enable" });
    },
  },
};
</script>
